import React, {
    useEffect, useState
} from 'react';
import {
    useSearchParams
} from 'react-router-dom';
import {
    AppLoader, LoaderContainerDiv
} from 'shared/components/LoaderSpinner';
import {
    FiCheckSquare
} from 'react-icons/fi';
import {
    AiOutlineClose
} from 'react-icons/ai';
import {
    authService
} from 'shared/api';

export default function VerifyEmail() {

    const [loading, setLoading] = useState(true);
    const [isVerified, setIsVerified] = useState(true);

    const [searchParams] = useSearchParams();
    const token = searchParams.get('token');
    useEffect(() => {
        if (!token) {
            setLoading(false);
            return;
        }

        authService.verify(token)
            .then(() => {

                setIsVerified(true);
            }).catch(() => {

            }).finally(() => {
                setLoading(false);
            });
    }, []);

    return (
        <div className='flex flex-grow flex-col items-center justify-center'>
            <div className='verify-email-box'>
                {loading ? (
                    <LoaderContainerDiv> <AppLoader size={50}/> </LoaderContainerDiv>
                ) : (
                    <div className='flex flex-col p-4 gap-4 items-center justify-center'>
                        {isVerified ?
                            (
                                <>
                                    <FiCheckSquare size={120} color='var(--primary-color)' />
                                    <div className='success-email-verified'>
                                        <span> Email Verified successfully </span>
                                    </div>
                                </>
                            ) : (
                                <>
                                    <AiOutlineClose size={120} color='var(--primary-color)' />
                                    <div className='failed-email-verified'>
                                        <span> Something went wrong </span>
                                    </div>
                                </>
                            )
                        }
                    </div>
                )}
            </div>
        </div>
    );
}
